export function roundOff(value, precision = 2) {
  return Number(parseFloat(value).toFixed(precision));
}

export function formatBalanceWithCr(balance) {
  if (balance == null || isNaN(balance)) return balance;
  return balance >= 0 ? balance : `${Math.abs(balance)} (cr)`;
}
